import { render, staticRenderFns } from "./RacunZaUplatuBase.vue?vue&type=template&id=9964550a&scoped=true&"
import script from "./RacunZaUplatuBase.vue?vue&type=script&lang=js&"
export * from "./RacunZaUplatuBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9964550a",
  null
  
)

export default component.exports